<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Create",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editRequestOrder' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_REQUEST_ORDER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-request-order' });
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      // console.log("params",params)
      let objects = {
        property_id: params.property_id,
        visit_id: params.visit_id,
        uid: params.uid,
        updated_at: moment.tz(new Date(), this.time_zone_local),
        updated_by: this.$store.getters.user
      }
      let objects_item = {
        service_id: params.service_id,
        qty: 1,
        price: params.price,
        payment_status: params.status,
        assign_id: params.assign_id,
        time_to_finish: params.time_to_finish,
        admin_note: params.admin_note,
        updated_at: moment.tz(new Date(), this.time_zone_local),
        updated_by: this.$store.getters.user
      }
      // var products = params.products;
      this.triggerSave = false;
      if(this.mode == 'add'){
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        objects.code = await this.getOrderCode();
        objects_item.created_at = moment.tz(new Date(), this.time_zone_local);
        objects_item.created_by = this.$store.getters.user;
        await this.$apollo.mutate({
            mutation: DataServices.insertData('visit_need_to_request'),
            variables: {
              objects: objects
            }
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              objects_item.request_id = returning.id;
              await this.$apollo.mutate({
                  mutation: DataServices.insertData('visit_need_to_request_item'),
                  variables: {
                    objects: objects_item
                  }
              }).then(() => {
                // var returning_items = res.data[Object.keys(res.data)].returning[0];
                this.redirectEdit();
              })
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }else{
        // var user_id = this.$route.params.id;
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.request_id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('visit_need_to_request'),
            variables: variables
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              if (params.status == 'ST002') {
                const headers = {
                  "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
                };
                var dataUpd = {
                  object_id: returning.id,
                  uid: params.uid,
                  action_key:'NEED_TO_CONFIRM_ACCEPT'
                }
                await ApiRepository.post('_api/common/send_push_admin', dataUpd, {headers})
              }else if(params.status == 'ST003'){
                const headers = {
                  "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
                };
                var dataUpd1 = {
                  object_id: returning.id,
                  uid: params.uid,
                  action_key:'NEED_TO_CONFIRM_CANCEL'
                }
                await ApiRepository.post('_api/common/send_push_admin', dataUpd1, {headers})
              }
              objects_item.request_id = returning.id;
              await this.$apollo.mutate({
                  mutation: DataServices.updateData('visit_need_to_request_item'),
                  variables: {
                    'data_update': objects_item,
                    'where_key': {
                      'id': {'_eq': this.models.id}
                    }
                  }
              }).then(async () => {
                // var returning_items = res.data[Object.keys(res.data)].returning[0];
                this.redirectEdit();
              })
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async getOrderCode() {
      var now = new Date();
      var gqLQueryCount = DataServices.countData("visit_need_to_request");
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key: {
            created_at: {_gte: moment(now, this.time_zone_local).startOf('day').toDate(), _lte: moment(now, this.time_zone_local).endOf('day').toDate()}
          }
        }
      });
      var total = countRes.data['visit_need_to_request_aggregate']['aggregate']['count'] + 1;
      var dateImport = moment(now, this.time_zone_local).format("YYYYMMDD");
      var code = `REQUEST${dateImport}${('0000' + total).substr(String(total).length)}`;
      return code;
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-request-order'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('visit_need_to_request_item', {
          "fields" : `id request_id price payment_method payment_status assign{id fullname} time_to_finish admin_note note status obj_service{id name need_assign time_to_finish type_of_price call_to_action_price type_of_property_arr{call_to_action_price type_id}} request{id code visit{id departure arrival week_number visit_start visit_end user {id fullname}} property{id code name type_id}} order_item{id payment_status order{id code payment_method status is_done}}`
        }),
        variables: {
          where_key: {
            id: {'_eq': id},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    /* margin-bottom: 16px; */
    padding-bottom: 10px;
    /* border-bottom: 1px solid #EEEEEE; */
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>